module.exports = __webpack_public_path__ + "img/amanda.70f76eca.jpeg";